import { render, staticRenderFns } from "./AdminEventDetails.vue?vue&type=template&id=433b7dd4&scoped=true"
import script from "./AdminEventDetails.vue?vue&type=script&lang=js"
export * from "./AdminEventDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminEventDetails.vue?vue&type=style&index=0&id=433b7dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433b7dd4",
  null
  
)

export default component.exports